import {MODULE_NAME} from "./constants";

export const SEARCH = `${MODULE_NAME}/SEARCH`;
export const VIEW_TEMPLATE = `${MODULE_NAME}/VIEW_TEMPLATE`;
export const SELECT_TEMPLATE = `${MODULE_NAME}/SELECT_TEMPLATE`;
export const USE_TEMPLATE = `${MODULE_NAME}/USE_TEMPLATE`;
export const DELETE = `${MODULE_NAME}/DELETE`;
export const SAVE_TEMPLATE = `${MODULE_NAME}/SAVE_TEMPLATE`;
export const UPDATE_TEMPLATE = `${MODULE_NAME}/UPDATE_TEMPLATE`;